<div *ngIf="lightboxVisible" class="lprImageLightboxViewer">
  <fs-image-lightbox-viewer
    [images]="lightboxImages"
    [isVisible]="true"
    (lightboxClosed)="closeLightbox()"
    [plate]="plate"
    [croppedImageUrl]="croppedImageUrl"
    [plateText]="plate.plate"
    [plateId]="plate.id"
  >
    <sn-text-icon-button
      fullscreenHeaderContent
      [class.marked-for-review]="isMarkedForReview"
      (click)="toggleMarkForReview()"
      [label]="(isMarkedForReview ? 'alpr.actions.markedForReview' : 'alpr.actions.markForReview') | t"
      [icon]="isMarkedForReview ? 'bookmark' : 'bookmark_border'"
    ></sn-text-icon-button>
  </fs-image-lightbox-viewer>
</div>
<mat-card class="resultCard" [class.selected]="selected" [id]="plateCardId">
  <div>
    <div class="timeAndMenu">
      <div class="time" *ngIf="plate.createdTimestamp">
        {{ plate.createdTimestamp | fsFormatDate : 'timeFirstNoAmPm' }}
      </div>
      <button
        mat-icon-button
        data-testid="mark-for-review-button"
        [class.marked-for-review]="isMarkedForReview"
        (click)="$event.stopPropagation(); toggleMarkForReview()"
        [matTooltip]="(isMarkedForReview ? 'alpr.actions.markedForReview' : 'alpr.actions.markForReview') | t"
        matTooltipPosition="below"
      >
        <sn-icon [fontSet]="isMarkedForReview ? 'fas' : 'fal'" fontIcon="fa-bookmark"></sn-icon>
      </button>
      <button
        mat-icon-button
        [matMenuTriggerFor]="lprOptions"
        (click)="$event.stopPropagation()"
        *ngIf="!onMap"
      >
        <sn-icon>more_horiz</sn-icon>
      </button>
    </div>
  </div>

  <div class="contextImage">
    <canvas
      *ngIf="activeMedia?.url && !canvasFailed"
      [id]="'context-' + plate.id"
      class="context-canvas image"
    >
    </canvas>
    <img
      *ngIf="activeMedia?.url && canvasFailed && !hasExternalFlockV3Link"
      [src]="activeMedia.url"
      class="image"
      (error)="setPlaceholderImage($event)"
    />
    <button
      class="view-larger-button"
      (click)="$event.stopPropagation(); viewLarger()"
      *ngIf="activeMedia && !hasImageLoadError && plateImageUrl"
    >
      <sn-icon>fullscreen</sn-icon>
      <span>{{ 'alpr.actions.viewLarger' | t }}</span>
    </button>
    <!-- NOTE: ONLY Flock V3 has this limitation, hence the hardcoded text -->
    <div class="flock-v3-external-link-info" *ngIf="!plateImageUrl && hasExternalFlockV3Link" data-testid="flock-image-not-provided">
      <p>{{ 'alpr.flockSafety.imageNotProvided' | t }}</p>
      <sn-flat-button color="primary" (click)="openExternalFlockV3Link($event)" data-testid="view-in-flock-safety-btn">
        <sn-icon>open_in_new</sn-icon>
        <sn-button-label>{{ 'alpr.actions.viewInFlockSafety' | t }}</sn-button-label>
      </sn-flat-button>
    </div>
  </div>

  <div class="mainContent">
    <div class="plateImage">
      <img
        [src]="plateImageUrl ? plateImageUrl : placeHolderSmallImageUrl"
        (error)="setPlatePlaceholderImage($event)"
      />
    </div>

    <div class="plateTextGroup">
      <div class="plateText">
        {{ plate.plate || ('alpr.noInfo' | t) }}
      </div>

      <button
        class="copyIconButton"
        mat-icon-button
        [cdkCopyToClipboard]="plate.plate"
        (click)="$event.stopPropagation()"
        [matTooltip]="'alpr.actions.copyPlate' | t"
      >
        <sn-icon class="copyIcon">content_copy</sn-icon>
      </button>
    </div>

    <span class="dotSeparator">•</span>

    <div class="plateState">
      <span class="state" [class.empty]="!plate.displayState">{{
        plate.displayState ? (plate.displayState | fsStateConvert : 'short') : '—'
      }}</span>
    </div>

    <span class="warning-icon-right" *ngIf="warningTooltip && !isReviewingPlates">
      <sn-icon
        fontSet="fa-solid"
        fontIcon="fa-triangle-exclamation"
        [matTooltip]="warningTooltip"
      ></sn-icon>
    </span>

  </div>
  <mat-card-footer class="resultCardFooter" [class.is-hit]="isHit">
    <div *ngIf="lprSharingEnabled && plate.isSharedRecord" class="sharingAgencyTooltip">
      <sn-icon
        fontSet="fa"
        fontIcon="fa-share-alt"
        [matTooltip]="sharingAgencyNameTooltip"
      ></sn-icon>
    </div>
    <div class="cameraName">
      <ng-container *ngIf="plate.integratedLprType === 'vigilant'; else defaultCameraTmpl">
        <span *ngIf="plate.details?.cameraName" [matTooltip]="plate.details.cameraName">{{
          plate.details.cameraName
        }}</span>
        <span *ngIf="!plate.details?.cameraName" class="empty">{{ 'alpr.deviceInfoNotAvailable' | t }}</span>
      </ng-container>
      <ng-template #defaultCameraTmpl>
        <span *ngIf="plate.cameraName" [matTooltip]="plate.cameraName">{{ plate.cameraName }}</span>
        <span *ngIf="!plate.cameraName" class="empty">{{ 'alpr.deviceInfoNotAvailable' | t }}</span>
      </ng-template>
    </div>
    <div class="circular-alert-icon" *ngIf="isHit" [matTooltip]="hitTooltipText">
      <sn-icon fontSet="fal" fontIcon="fa-circle-exclamation" class="mr-1 hit-alert-icon" size="lg">
      </sn-icon>
    </div>
  </mat-card-footer>
</mat-card>
<mat-menu #lprOptions="matMenu">
  <button mat-menu-item (click)="sendToVault(plate)">
    <span>{{ 'common.addToVault' | t }}</span>
  </button>
  <button
    *ngIf="shouldShowDownloadButton"
    [disabled]="!activeMedia || plate?.overviewImageKey"
    mat-menu-item
    (click)="downloadImage(plate)"
  >
    <span>{{ 'alpr.actions.downloadImage' | t }}</span>
  </button>
</mat-menu>
